module.exports = __webpack_public_path__ + "img/eyes_female_thin_mask.415a5c29.png";